import { render, staticRenderFns } from "./BBBRawFiles.vue?vue&type=template&id=eb0b55a4&"
import script from "./BBBRawFiles.vue?vue&type=script&lang=js&"
export * from "./BBBRawFiles.vue?vue&type=script&lang=js&"
import style0 from "./BBBRawFiles.vue?vue&type=style&index=0&id=eb0b55a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports